<script>
  import Stories from "../../assets/svgs/signin.svg";
  export let width = window.innerWidth > 700 ? "40vw" : "60vw";
  export let height = width;
</script>

<div class="signin-stories-container">
  <Stories width="{width}" height="{height}" />
</div>
